/**
 * Test IDs for admin panel - data-testid constants
 */
export const ADMIN = {
  // Layout
  sidebar: "admin-sidebar",
  navDashboard: "admin-nav-dashboard",
  navKeys: "admin-nav-keys",
  navPlaylists: "admin-nav-playlists",
  navDevices: "admin-nav-devices",
  navBranding: "admin-nav-branding",
  navNotifications: "admin-nav-notifications",
  navUpdates: "admin-nav-updates",

  // Dashboard
  statKeys: "stat-keys",
  statDevices: "stat-devices",
  statPlaylists: "stat-playlists",
  statContent: "stat-content",

  // Keys
  btnGenerateKey: "btn-generate-key",
  generateKeyDialog: "generate-key-dialog",
  generateKeyNote: "generate-key-note",
  generateKeyConfirm: "generate-key-confirm",
  keyRow: (id) => `key-row-${id}`,
  btnAssignPlaylists: (id) => `btn-assign-playlists-${id}`,
  btnDeleteKey: (id) => `btn-delete-key-${id}`,
  btnCopyKey: (id) => `btn-copy-key-${id}`,
  assignDialog: "assign-playlists-dialog",
  assignSave: "assign-playlists-save",
  btnInlineAddPlaylist: "btn-inline-add-playlist",
  inlinePlaylistName: "inline-playlist-name",
  inlinePlaylistUrl: "inline-playlist-url",
  inlinePlaylistDesc: "inline-playlist-desc",
  inlinePlaylistCreate: "inline-playlist-create",
  inlinePlaylistCancel: "inline-playlist-cancel",

  // Playlists
  btnAddPlaylist: "btn-add-playlist",
  addPlaylistDialog: "add-playlist-dialog",
  playlistName: "playlist-name",
  playlistM3uUrl: "playlist-m3u-url",
  playlistDescription: "playlist-description",
  playlistSave: "playlist-save",
  playlistRow: (id) => `playlist-row-${id}`,
  btnReparse: (id) => `btn-reparse-${id}`,
  btnDeletePlaylist: (id) => `btn-delete-playlist-${id}`,

  // Devices
  deviceRow: (id) => `device-row-${id}`,
  devicePlatformFilter: "device-platform-filter",
  btnDeviceBlock: (id) => `btn-device-block-${id}`,
  btnDeviceUnblock: (id) => `btn-device-unblock-${id}`,
  btnDeleteDevice: (id) => `btn-delete-device-${id}`,

  // Branding
  logoUploadDesktop: "logo-upload-desktop",
  logoUploadMobile: "logo-upload-mobile",
  logoUploadIcon: "logo-upload-icon",
  introUploadDesktop: "intro-upload-desktop",
  introUploadMobile: "intro-upload-mobile",
  appNameInput: "app-name-input",
  btnSaveAppName: "btn-save-app-name",

  // Notifications
  btnSendNotification: "btn-send-notification",
  sendNotifDialog: "send-notif-dialog",
  notifTitle: "notif-title",
  notifMessage: "notif-message",
  notifTargetType: "notif-target-type",
  notifSendConfirm: "notif-send-confirm",
  notifRow: (id) => `notif-row-${id}`,
  btnDeleteNotif: (id) => `btn-delete-notif-${id}`,

  // Updates
  versionInput: (platform) => `version-input-${platform}`,
  updateUrlInput: (platform) => `update-url-input-${platform}`,
  changelogInput: (platform) => `changelog-input-${platform}`,
  forceUpdateSwitch: (platform) => `force-update-switch-${platform}`,
  btnSaveVersion: (platform) => `btn-save-version-${platform}`,
};
